import { Metadata } from '../../../../utils/spds/metadata';
import Super from './row.gjs';

const METADATA = Metadata.define({
  description: `
Flex reverse row layout component

A convenience wrapper around \`Spds::Core::Container\` that renders a reversed flexbox row. It sets \`@reverse={{true}}\`
on the underlying container, so items flow from right to left (in left-to-right languages). Use it when the visual order
needs to be inverted without changing the DOM order.
  `,
  name: 'Flex Reverse Row',
});

export default class SpdsLayoutFlexReverseRow extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  reverse = true;
  variantClass = 'spds-layout-flex-reverse-row';
}

export const LAYOUT_FLEX_REVERSE_ROW_METADATA = SpdsLayoutFlexReverseRow.metadata;
